document.addEventListener('DOMContentLoaded', function() {
    const materials_link = document.querySelector('.icon-attachment');
    materials_link.outerHTML = `<a href="./materials">${materials_link.outerHTML}</a>`;
});
